import { createFeatureSelector, createSelector } from '@ngrx/store';
import { User } from 'src/app/models/user.model';
import * as fromDashboard from '../../reducers/dashboard/dashboard.reducer';
import * as fromOrders from '../../reducers/orders/orders.reducer';

export const selectOrdersFeature = createFeatureSelector<fromOrders.State>(
  fromOrders.ordersFeatureKey
);

export const selectDashboardStateFeature =
  createFeatureSelector<fromDashboard.State>(fromDashboard.dashboardFeatureKey);

// INTERFACES
export interface OrdersModel {
  orders: any;
}

export interface OrdersDataModel {
  orderData: any;
}
export interface OrdersUserModel {
  userDetails: User | null;
}

// SELECTORS
export const selectOrders = createSelector(
  selectOrdersFeature,
  (state: fromOrders.State): OrdersModel => {
    return {
      orders: state.retailOrders
    };
  }
);

export const selectOrdersData = createSelector(
  selectOrdersFeature,
  (state: fromOrders.State): OrdersDataModel => {
    return {
      orderData: state.orderData
    };
  }
);

export const selectUserData = createSelector(
  selectDashboardStateFeature,
  (state: fromDashboard.State): OrdersUserModel => {
    return {
      userDetails: state.userDetails
    };
  }
);
